import type { PrintSize } from './print'

/**
 * Print pricing (USD cents) for the simplified "Print Checkout" modal / create-checkout flow.
 *
 * IMPORTANT:
 * - Keep this aligned with `netlify/functions/create-checkout.ts` server-side PRICING constant.
 * - Do NOT reuse this for the legacy/embedded checkout flow unless you intentionally migrate it.
 */
export const PRINT_PRICING_CENTS = {
  small: 4900,
  medium: 6900,
  large: 8900,
} satisfies Record<PrintSize, number>

export const formatUSDFromCents = (cents: number): string =>
  `$${(cents / 100).toFixed(2)}`
